// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-accordion ion-item ion-label {
  font-size: 15px;
}

ion-card {
  width: 100%;
}

ion-card-content {
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/search-results/search-results/search-results.page.scss","webpack://./../../../../../../Program%20Files%20(x86)/Jenkins/workspace/Quadra%20Service%20Call%20Pipeline/QuadraServiceCall/Client/src/app/pages/search-results/search-results/search-results.page.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;ACCJ;;ADEA;EACI,WAAA;ACCJ;;ADEA;EACI,YAAA;ACCJ","sourcesContent":["ion-accordion ion-item ion-label {\r\n    font-size: 15px;\r\n}\r\n\r\nion-card {\r\n    width: 100%;\r\n}\r\n\r\nion-card-content {\r\n    color: black;\r\n}\r\n","ion-accordion ion-item ion-label {\n  font-size: 15px;\n}\n\nion-card {\n  width: 100%;\n}\n\nion-card-content {\n  color: black;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
